import { render, staticRenderFns } from "./CourseEventForm.vue?vue&type=template&id=500fb8a2"
import script from "./CourseEventForm.vue?vue&type=script&lang=js"
export * from "./CourseEventForm.vue?vue&type=script&lang=js"
import style0 from "./CourseEventForm.vue?vue&type=style&index=0&id=500fb8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports